import AccordionSummary from '@mui/material/AccordionSummary';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import { css, styled } from '@mui/material/styles';
import React from 'react';

export const TwAccordion = styled((props: AccordionProps) => (
  <Accordion disableGutters elevation={2} square {...props} />
))(() => ({
  borderRadius: '6px',
  border: '1px solid #E5E7EB',
  '&:before': {
    display: 'none'
  },
  marginBottom: '12px',
  boxShadow: 'none',
  backgroundColor: '#f9f7fa'
}));

export const TwAccordionDetails = styled(AccordionDetails)(() => ({
  borderTop: '1px solid #E5E7EB',
  fontSize: '14px',
  color: '#1F2937'
}));

export const TwAccordionSummary = styled(AccordionSummary)(() => ({
  flexDirection: 'row-reverse'
}));

export interface IExpandedItems {
  [key: string]: boolean;
}
